export const AI_TRANSLATION_ERROR =
  "Unable to generate translations at this time. Please try again.";

export const OVERWRITE_TRANSLATION_TITLE = "Overwrite translation?";

export const OVERWRITE_TRANSLATION_CONFIRMATION =
  "This translation already contains content. Are you sure you want to replace it with the AI-generated version?";

export const OVERWRITE_TRANSLATION_CONFIRM_LABEL = "Yes";

export const TASK_TRANSLATIONS_SAVE_ERROR =
  "The task was saved, but its translations could not be. Please reopen the task and try again.";
